import moment, { Moment } from 'moment';

import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface DateRangePreset {
    id: number;
    text: React.ReactNode;
    startValue: Moment;
    endValue: Moment;
}

export const createCustomPresets = (withAllOption): DateRangePreset[] => {
    const presets = [{
        id: 1,
        text: <FormattedMessage id='intl-msg:dateRangePicker.preset.today'/>,
        startValue: moment().startOf('day'),
        endValue: moment(),
    }, {
        id: 7,
        text: <FormattedMessage id='intl-msg:dateRangePicker.preset.last7Days'/>,
        startValue: moment().startOf('day').subtract(7, 'days'),
        endValue: moment(),
    }, {
        id: 10,
        text: <FormattedMessage id='intl-msg:dateRangePicker.preset.last10Days'/>,
        startValue: moment().startOf('day').subtract(10, 'days'),
        endValue: moment(),
    }, {
        id: 30,
        text: <FormattedMessage id='intl-msg:dateRangePicker.preset.last30Days'/>,
        startValue: moment().startOf('day').subtract(30, 'days'),
        endValue: moment(),
    }];
    return withAllOption ? [{
        id: 0,
        text: <FormattedMessage id='intl-msg:all'/>,
        startValue: moment(new Date(0)),
        endValue: moment().add(15, 'minutes'),
    }, ...presets] : presets;
};

export interface DateRangePresetNative {
    id: number;
    text: React.ReactNode;
    from: Date;
    to: Date;
}

/**
 * Native-Date variant of createCustomPresets for UIKIT 3 DayPicker (mode='range').
 * Kept alongside the moment-based createCustomPresets which is still used by DateRangePickerOTA.
 */
export const createCustomPresetsNative = (withAllOption?: boolean): DateRangePresetNative[] =>
    createCustomPresets(withAllOption).map(preset => ({
        id: preset.id,
        text: preset.text,
        from: preset.startValue.toDate(),
        to: preset.endValue.toDate(),
    }));
